!function (fun) {
  'function' == typeof define && define.amd ? define(fun) : fun()
}(function () {
  'use strict';

  /* --- Common - Start --- */

  const classHide = 'cil-hide',
    classRemoveMargin = 'cil-rm-margin';

  const selectorHeader = '.site-header';

  //
  //

  function scrollTo(element) {
    const header = document.querySelector(selectorHeader);
    const headerHeight = header.offsetHeight;

    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerHeight - 80;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  //

  function commonSaveInStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
    }

    sessionStorage.setItem(key, value);
  }

  function commonReadFromStorage(key) {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue !== null) {
      return savedValue;
    }

    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function commonRemoveFromStorge(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
    }

    sessionStorage.removeItem(key);
  }

  //
  //

  function getFormattedDate(daysToAdd) {
    var today = new Date();
    var reqDate = new Date(new Date().setDate(today.getDate() + daysToAdd));

    var wk = new Intl.DateTimeFormat('en', { weekday: 'short' }).format(reqDate);
    var mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(reqDate);
    var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(reqDate);

    return `${wk}, ${mo} ${da}`;
  }

  /* --- Common - End --- */

  //
  //
  //
  //
  //

  /* --- Pincode Checker - Start --- */

  function initPincheck() {
    const mynpcPincodeLen = 6,
      mynpcPincodeStorageKey = "mynpc_pincode";

    const mynpcInputCodeTextUnserviceableState = 'Unfortunately we do not ship to your pincode',
      mynpcInvalidPincodeMsg = 'Please enter a valid pincode',
      mynpcPlsTryAgainMsg = 'Please try again',
      mynpcGetByPrefix = 'Get it by ';

    const mynpcCheckStateClass = 'mynpc-state-check',
      mynpcServiceableStateClass = 'mynpc-state-serviceable',
      mynpcUnserviceableStateClass = 'mynpc-state-unserviceable',
      mynpcInputCodeTextErrorClass = 'mynpc-input-error',
      mynpcHideClass = 'mynpc-hide';

    const mynpcMainContainerSelector = '.mynpc-container',
      mynpcErrorContainerSelector = '.mynpc-error-container',
      mynpcErrorTextSelector = '.mynpc-error-text',
      mynpcDeliveryFormSelector = '.mynpc-check-delivery-form',
      mynpcDeliveryFormCodeInputSelector = '.mynpc-code-input',
      mynpcDeliveryFormCodeInputProductKeySelector = '.mynpc-code-input-product-key',
      mynpcCheckCodeButtonSelector = '.mynpc-check-code-button',
      mynpcChangeCodeButtonSelector = '.mynpc-change-code-button',
      mynpcInputCodeTextSelector = '.mynpc-input-code-text',
      mynpcDeliveryInfoListServiceableSelector = '.mynpc-delivery-info-list.mynpc-delivery-info-list-serviceable',
      mynpcDeliveryInfoListUnServiceableSelector = '.mynpc-delivery-info-list.mynpc-delivery-info-list-unserviceable',
      mynpcDeliveryInfoGetBySelector = '.mynpc-delivery-info-get-by',
      mynpcDeliveryInfoInstallSelector = '.mynpc-delivery-info-install',
      mynpcDeliveryInfoItemTitleSelector = '.mynpc-delivery-info-item-title';

    //
    //
    //

    function mynpcEnableInputCode(mainContainer) {
      var codeInput = mainContainer.querySelector(mynpcDeliveryFormCodeInputSelector);
      codeInput.disabled = false;
    }

    function mynpcDisableInputCode(mainContainer) {
      var codeInput = mainContainer.querySelector(mynpcDeliveryFormCodeInputSelector);
      codeInput.disabled = true;
    }

    //
    //

    function mynpcClearPincode(mainContainer) {
      commonRemoveFromStorge(mynpcPincodeStorageKey);

      var codeInput = mainContainer.querySelector(mynpcDeliveryFormCodeInputSelector);
      codeInput.value = '';
    }

    //

    function mynpcShowErrorMsg(mainContainer, msg) {
      const errorContainer = mainContainer.querySelector(mynpcErrorContainerSelector);
      var errorText = mainContainer.querySelector(mynpcErrorTextSelector);

      errorText.innerText = msg;

      errorContainer.classList.remove(mynpcHideClass);
      setTimeout(function () {
        errorContainer.classList.add(mynpcHideClass);
      }, 3000);
    }

    //
    //
    //

    function mynpcSwitchToCheckState(mainContainer) {
      mainContainer.classList.remove(mynpcServiceableStateClass);
      mainContainer.classList.remove(mynpcUnserviceableStateClass);
      mainContainer.classList.add(mynpcCheckStateClass);

      mynpcEnableInputCode(mainContainer);
      mynpcClearPincode(mainContainer);
    }

    //
    //

    function mynpcSwitchToServiceableState(mainContainer, respJson) {
      var basicJson = respJson.data.basic;
      var customFieldsJson = basicJson.custom_fields;

      //

      var infoListServiceable = mainContainer.querySelector(mynpcDeliveryInfoListServiceableSelector);

      var getBy = infoListServiceable.querySelector(mynpcDeliveryInfoGetBySelector);
      if (getBy) {
        var getByTitle = getBy.querySelector(mynpcDeliveryInfoItemTitleSelector);
        getByTitle.innerText = mynpcGetByPrefix + getFormattedDate(basicJson.delivery_in_days);
      }

      var install = infoListServiceable.querySelector(mynpcDeliveryInfoInstallSelector);
      if (install) {
        var installTitle = install.querySelector(mynpcDeliveryInfoItemTitleSelector);
        var videoLink = parseInstallVideoLink(install);

        var reqInnerHtml;

        var installationFree;
        if (customFieldsJson['installation_free']) {
          var installationFreeStr = customFieldsJson['installation_free'].toLowerCase();
          if (installationFreeStr === "true") {
            installationFree = true;
          } else {
            installationFree = false;
          }
        } else {
          installationFree = false;
        }

        var installationAvl;
        if (customFieldsJson['installation_available']) {
          var installationAvlStr = customFieldsJson['installation_available'].toLowerCase();
          if (installationAvlStr === "true") {
            installationAvl = true;
          } else {
            installationAvl = false;
          }
        } else {
          installationAvl = false;
        }

        if (installationFree) {
          reqInnerHtml = "Free installation is available at your location."
        } else if (installationAvl) {
          reqInnerHtml = "We’re happy to offer you a paid installation."
          reqInnerHtml += " <span>Click here to <a href=\""
                + "/products/office-chair-assembly-by-green-soul-xperts?variant=47065138463037"
                + "\" target=\"_blank\">add service</a>.</span>"
        } else {
          reqInnerHtml = "We don't offer installation at your location."
          if ( videoLink !== null ) {
            reqInnerHtml += " <span>But don't worry - Follow <a href=\"" + videoLink
              + "\" target=\"_blank\">this</a> installation video and do it yourself within no time!</span>"
          }
        }

        installTitle.innerHTML = reqInnerHtml
      }

      //

      mainContainer.classList.remove(mynpcCheckStateClass);
      mainContainer.classList.remove(mynpcUnserviceableStateClass);
      mainContainer.classList.add(mynpcServiceableStateClass);

      mynpcDisableInputCode(mainContainer);
    }

    function parseInstallVideoLink(installEle) {
      var videoLinkStr = installEle.getAttribute('data-video-link');
      if ( videoLinkStr !== null && videoLinkStr.length > 0 ) {
        return videoLinkStr;
      }

      //

      var installFaqStr = installEle.getAttribute('data-faq');

      try {
        var doc = new DOMParser().parseFromString(installFaqStr, "text/html");

        //

        var iframeEle = doc.querySelector('iframe');
        if ( iframeEle !== null ) {
          videoLinkStr = iframeEle.getAttribute("src");
          installEle.setAttribute('data-video-link', videoLinkStr);
          return videoLinkStr;
        }

        //

        var anchorEle = doc.querySelector('a');
        if ( anchorEle !== null ) {
          videoLinkStr = anchorEle.getAttribute("href");
          installEle.setAttribute('data-video-link', videoLinkStr);
          return videoLinkStr;
        }
      }
      catch(err) {
        console.log(err);
        return null;
      }

      console.log("Unable to parse video link");
      return null;
    }

    //
    //

    function mynpcSwitchToUnserviceableState(mainContainer) {
      mainContainer.classList.remove(mynpcCheckStateClass);
      mainContainer.classList.remove(mynpcServiceableStateClass);
      mainContainer.classList.add(mynpcUnserviceableStateClass);

      mynpcDisableInputCode(mainContainer);

      //

      var inputCodeText = mainContainer.querySelector(mynpcInputCodeTextSelector);

      var infoListUnserviceable = mainContainer.querySelector(mynpcDeliveryInfoListUnServiceableSelector);
      if (infoListUnserviceable) {
        inputCodeText.classList.add(mynpcHideClass);
      } else {
        inputCodeText.innerText = mynpcInputCodeTextUnserviceableState;
        inputCodeText.classList.add(mynpcInputCodeTextErrorClass);
        inputCodeText.classList.remove(mynpcHideClass);
      }
    }

    //
    //
    //

    function mynpcInitEventHandlers() {
      var deliveryFormEles = document.querySelectorAll(mynpcDeliveryFormSelector);

      var index = 0;
      while (index < deliveryFormEles.length) {
        var deliveryForm = deliveryFormEles[index];

        deliveryForm.onsubmit = function (event) {
          event.preventDefault();
          mynpcProcessFormSubmit(this, true);
        }

        //

        const inputProductKey = deliveryForm.querySelector(mynpcDeliveryFormCodeInputProductKeySelector);

        document.addEventListener('cil-variant-change', function(e) {
          var sku = e.detail.variant.sku;;
          if (!!sku && inputProductKey.value !== sku) {
            inputProductKey.value = sku;

            inputProductKey.dispatchEvent(new Event('change'));
          }
        });

        inputProductKey.addEventListener('change', function(e) {
          mynpcProcessFormSubmit(deliveryForm, false);
        });


        //

        index += 1;
      }

      //

      var codeInputEles = document.querySelectorAll(mynpcDeliveryFormCodeInputSelector);

      var index = 0;
      while (index < codeInputEles.length) {
        var codeInput = codeInputEles[index];

        codeInput.onchange = function (event) {
          return mynpcProcessFormPincodeInput(this);
        }
        codeInput.onkeyup = function (event) {
          return mynpcProcessFormPincodeInput(this);
        }

        index += 1;
      }

      //

      var changeCodeButtonEles = document.querySelectorAll(mynpcChangeCodeButtonSelector);

      var index = 0;
      while (index < changeCodeButtonEles.length) {
        var changeCodeButton = changeCodeButtonEles[index];

        changeCodeButton.addEventListener("click", function (event) {
          event.preventDefault();

          var mainContainer = this.closest(mynpcMainContainerSelector);

          mynpcSwitchToCheckState(mainContainer);
        });

        index += 1;
      }
    }

    //
    //

    function mynpcProcessFormSubmit(form, showError) {
      var mainContainer = form.closest(mynpcMainContainerSelector);

      var pincode = form.querySelector(mynpcDeliveryFormCodeInputSelector).value;
      var productKey = form.querySelector(mynpcDeliveryFormCodeInputProductKeySelector).value;

      var pincodeInt = parseInt(pincode, 10);
      const pincodeToCheck = pincodeInt.toString();

      if (isNaN(pincodeInt) || pincodeToCheck.length !== 6) {
        if (showError) {
          mynpcShowErrorMsg(mainContainer, mynpcInvalidPincodeMsg);
        }

        return;
      }

      //

      var httpRequest = new XMLHttpRequest();

      var httpRequestUrl = "https://api-pincheck.upscalio.com/accounts/23ffd7cf-bbf7-47ea-90d6-a2063ee7000b/delivery/pincodes/" + pincodeToCheck;
      httpRequestUrl += "?product_key=" + encodeURIComponent(productKey)

      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState !== 4) {
          return;
        }

        commonSaveInStorage(mynpcPincodeStorageKey, pincodeToCheck);

        if (httpRequest.status === 200) {
          var respJson = JSON.parse(httpRequest.responseText);
          mynpcSwitchToServiceableState(mainContainer, respJson);
          return;
        }

        if (httpRequest.status === 404) {
          mynpcSwitchToUnserviceableState(mainContainer);
          return;
        }

        if (httpRequest.status === 400) {
          mynpcShowErrorMsg(mainContainer, mynpcInvalidPincodeMsg);
          return;
        }

        mynpcShowErrorMsg(mainContainer, mynpcPlsTryAgainMsg);
      }

      httpRequest.open("GET", httpRequestUrl, true);
      httpRequest.send(null);
    }

    //

    function mynpcProcessFormPincodeInput(codeInput) {
      var value = codeInput.value,
        valueInt = parseInt(value, 10);

      if (!isNaN(valueInt) && valueInt) {
        value = valueInt.toString();

        if (value.length <= mynpcPincodeLen) {
          codeInput.value = value;
        } else {
          codeInput.value = value.substring(0, mynpcPincodeLen);
        }

        return true;
      }

      if ('' === value) {
        codeInput.value = value;
        return true;
      }

      codeInput.value = '';
      return false;
    }

    //
    //
    //

    mynpcInitEventHandlers();

    //

    var mainContainerEles = document.querySelectorAll(mynpcMainContainerSelector);

    var index = 0;
    while (index < mainContainerEles.length) {
      var mainContainer = mainContainerEles[index];

      mainContainer.classList.remove(mynpcHideClass);

      index += 1;
    }

    //

    const mynpcSavedPincode = commonReadFromStorage(mynpcPincodeStorageKey);
    if (mynpcSavedPincode !== null) {
      var codeInputEles = document.querySelectorAll(mynpcDeliveryFormCodeInputSelector);

      var index = 0;
      while (index < codeInputEles.length) {
        var codeInput = codeInputEles[index];
        codeInput.value = mynpcSavedPincode;

        var parentEle = codeInput.parentElement;

        var checkCodeButton = parentEle.querySelector(mynpcCheckCodeButtonSelector);
        checkCodeButton.click();

        index += 1;
      }
    }
  }

  /* --- Pincode Checker - End --- */

  //
  //
  //
  //
  //

  /* --- Youtube video - Start --- */

  function initYoutubeVideo() {
    document.querySelectorAll('.cil-youtube-video-box').forEach(container => {
      let banner = container.querySelector('.cil-banner');
      let videoBox = container.querySelector('.cil-video-box');

      if (banner && videoBox) {
        let video = videoBox.querySelector('.cil-video');
        if (video) {
          banner.addEventListener("click", function (event) {
            event.preventDefault();

            banner.style.display = 'none';
            video.src += '?autoplay=1&mute=1';

            setTimeout(function () {
              videoBox.style.display = 'block';
            }, 200);
          });
        }
      }
    });
  }

  /* --- Youtube video - End --- */

  //
  //
  //
  //
  //

  /* --- Search Inpage - Start --- */

  function initSearchInPage() {
    document.querySelectorAll('.cil-search-container.cil-inpage').forEach(container => {
      const dataSearchAttr = container.getAttribute('data-search-attr');
      if (!dataSearchAttr) {
        return;
      }

      const noResultsTxtPrefix = container.getAttribute('data-nr-prefix');
      const noResultsLink = container.getAttribute('data-nr-link');
      const noResultsLinkTxt = container.getAttribute('data-nr-link-text');

      //
      //

      const elesForSearch = [];

      document.querySelectorAll('[' + dataSearchAttr + ']').forEach(eleForSearch => {
        const value = eleForSearch.getAttribute(dataSearchAttr);

        elesForSearch.push({
          "element": eleForSearch,
          "value": value,
          "value_lc": value.toLowerCase()
        });
      });

      if (elesForSearch.length == 0) {
        return;
      }

      //
      //

      const input = container.querySelector('.cil-search-input');
      const dropdown = container.querySelector('.cil-dropdown-menu');

      if (!input || !dropdown) {
        return;
      }

      input.addEventListener('input', function(event) {
        event.preventDefault();
        event.stopPropagation();

        let dataProcessing = container.getAttribute('data-processing');
        if (dataProcessing === 'true') {
          return;
        }

        container.setAttribute('data-processing', true);

        //

        const curSearch = input.value.toLowerCase();

        dropdown.innerHTML = ''; // Clear previous results

        elesForSearch.forEach(eleForSearch => {
          if (!eleForSearch["value_lc"].includes(curSearch)) {
            return;
          }

          const li = document.createElement('li');
          li.textContent = eleForSearch["value"];

          li.addEventListener('click', function() {
            dropdown.style.display = 'none';
            scrollTo(eleForSearch["element"]);
          });

          dropdown.appendChild(li);
        });

        let hasResults = dropdown.childElementCount > 0;

        if (!hasResults && curSearch !== '') {
          const noResultsItem = document.createElement('li');

          if (noResultsLink && noResultsLink.trim() !== '') {
            noResultsItem.appendChild(document.createTextNode(noResultsTxtPrefix));

            let noResultsItemLink = document.createElement('a');
            noResultsItemLink.href = noResultsLink;
            noResultsItemLink.textContent = noResultsLinkTxt;

            noResultsItem.appendChild(noResultsItemLink);
          } else {
            noResultsItem.textContent = noResultsTxtPrefix;
          }

          dropdown.appendChild(noResultsItem);

          hasResults = true;
        }

        dropdown.style.display = (hasResults && curSearch !== '') ? 'block' : 'none';

        //

        container.setAttribute('data-processing', false);
      });

      input.addEventListener('focus', function() {
        // Simulate a search input event to display all results
        this.dispatchEvent(new Event('input'));
      });

      input.addEventListener('blur', function() {
        setTimeout(() => {
          dropdown.style.display = 'none';
        }, 200); // Delay to allow click event to fire on list item
      });

      //
      //

      let dataRemoveTopMargin = container.getAttribute('data-rtp-margin');
      let ancestor = container.closest('.wrapper-container');
      if (dataRemoveTopMargin === 'true' && ancestor) {
        ancestor.classList.add(classRemoveMargin);
      }

      //
      //

      container.classList.remove(classHide);
    });
  }

  /* --- Search Inpage - End --- */

  //
  //
  //
  //
  //

  /* --- Generic - Start --- */

  function initGeneric() {
    document.body.setAttribute('data-cil-dom-loaded', 'true');
  }

  /* --- Generic - End --- */

  //
  //
  //
  //
  //

  document.addEventListener('DOMContentLoaded', function () {
    initGeneric();

    initPincheck();

    initYoutubeVideo();

    initSearchInPage();
  }, false);

});